import {Lang, PersonalityType} from '@context/CompetitionImamrezaContext';
import React from 'react';
import arpl_ar_01 from './assets/images/artist/pl-ar-01.webp';
import arpl_ar_02 from './assets/images/artist/pl-ar-02.webp';

// Artist PL Images
import arpl_en_01 from './assets/images/artist/pl-en-01.webp';
import arpl_en_02 from './assets/images/artist/pl-en-02.webp';
import arpl_fa_01 from './assets/images/artist/pl-fa-01.webp';
import arpl_fa_02 from './assets/images/artist/pl-fa-02.webp';
import inpl_ar_01 from './assets/images/interaction/pl-ar-01.webp';
import inpl_ar_02 from './assets/images/interaction/pl-ar-02.webp';

// Interaction PL Images
import inpl_en_01 from './assets/images/interaction/pl-en-01.webp';
import inpl_en_02 from './assets/images/interaction/pl-en-02.webp';
import inpl_fa_01 from './assets/images/interaction/pl-fa-01.webp';
import inpl_fa_02 from './assets/images/interaction/pl-fa-02.webp';

// Line Separator
import line from './assets/images/line.webp';
import pcpl_ar_01 from './assets/images/peaceful/pl-ar-01.webp';
import pcpl_ar_02 from './assets/images/peaceful/pl-ar-02.webp';

// Peaceful PL Images
import pcpl_en_01 from './assets/images/peaceful/pl-en-01.webp';
import pcpl_en_02 from './assets/images/peaceful/pl-en-02.webp';
import pcpl_fa_01 from './assets/images/peaceful/pl-fa-01.webp';
import pcpl_fa_02 from './assets/images/peaceful/pl-fa-02.webp';
import srpl_ar_01 from './assets/images/searcher/pl-ar-01.webp';
import srpl_ar_02 from './assets/images/searcher/pl-ar-02.webp';

// Searcher PL Images
import srpl_en_01 from './assets/images/searcher/pl-en-01.webp';
import srpl_en_02 from './assets/images/searcher/pl-en-02.webp';
import srpl_fa_01 from './assets/images/searcher/pl-fa-01.webp';
import srpl_fa_02 from './assets/images/searcher/pl-fa-02.webp';
import svpl_ar_01 from './assets/images/servant/pl-ar-01.webp';
import svpl_ar_02 from './assets/images/servant/pl-ar-02.webp';

// Servant PL Images
import svpl_en_01 from './assets/images/servant/pl-en-01.webp';
import svpl_en_02 from './assets/images/servant/pl-en-02.webp';
import svpl_fa_01 from './assets/images/servant/pl-fa-01.webp';
import svpl_fa_02 from './assets/images/servant/pl-fa-02.webp';

// Define per personality images per Lang
const peacefulImages: Record<Lang, {first: string; second: string}> = {
	en: {first: pcpl_en_01, second: pcpl_en_02},
	fa: {first: pcpl_fa_01, second: pcpl_fa_02},
	ar: {first: pcpl_ar_01, second: pcpl_ar_02}
};

const artistImages: Record<Lang, {first: string; second: string}> = {
	en: {first: arpl_en_01, second: arpl_en_02},
	fa: {first: arpl_fa_01, second: arpl_fa_02},
	ar: {first: arpl_ar_01, second: arpl_ar_02}
};

const interactionImages: Record<Lang, {first: string; second: string}> = {
	en: {first: inpl_en_01, second: inpl_en_02},
	fa: {first: inpl_fa_01, second: inpl_fa_02},
	ar: {first: inpl_ar_01, second: inpl_ar_02}
};

const servantImages: Record<Lang, {first: string; second: string}> = {
	en: {first: svpl_en_01, second: svpl_en_02},
	fa: {first: svpl_fa_01, second: svpl_fa_02},
	ar: {first: svpl_ar_01, second: svpl_ar_02}
};

const searcherImages: Record<Lang, {first: string; second: string}> = {
	en: {first: srpl_en_01, second: srpl_en_02},
	fa: {first: srpl_fa_01, second: srpl_fa_02},
	ar: {first: srpl_ar_01, second: srpl_ar_02}
};

interface PilgrimageModeContentProps {
	type: PersonalityType;
	lang: Lang;
}

export const PilgrimageModeContent = ({type, lang}: PilgrimageModeContentProps) => {
	const getContent = (images: {first: string; second: string}) => (
		<div className="w-full flex flex-col gap-y-10 font-aria word-spacing-tighter">
			<div className="w-10/12 mx-auto flex flex-col gap-y-10">
				<img src={images.first} alt={type} className="w-full h-fit"/>
				<img src={line} alt="separator" className="w-5/12 h-fit mx-auto"/>
				<img src={images.second} alt={type} className="w-full h-fit"/>
			</div>
		</div>
	);
	const contentMap: Record<PersonalityType, JSX.Element> = {
		peaceful: getContent(peacefulImages[lang]),
		artist: getContent(artistImages[lang]),
		interaction: getContent(interactionImages[lang]),
		servant: getContent(servantImages[lang]),
		searcher: getContent(searcherImages[lang])
	};
	return contentMap[type] || <div>No content</div>;
};
